import React from 'react';
import PropTypes from 'prop-types';

const Check = ({ color = '#224251', ...props }) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.13299 19L3.35968 13.2267C2.88011 12.7471 2.88011 11.9719 3.35968 11.4924C3.83803 11.0128 4.61443 11.0128 5.09401 11.4924L9.13299 15.5314L19.3047 5.35968C19.783 4.88011 20.5594 4.88011 21.039 5.35968C21.5173 5.83926 21.5173 6.61443 21.039 7.09401L9.13299 19Z"
      fill={color}
    />
  </svg>
);

Check.propTypes = {
  color: PropTypes.string
};

export default Check;
